import { TextInput } from '../../controls/text-input';
import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues, Control } from 'react-hook-form';

export interface TextFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<FieldWrapperProps, 'children'> {
  isReadOnly?: boolean;
  showError?: boolean;
  control?: Control<T>;
  isSmallSize?: boolean;
  layoutForm?: 'vertical' | 'horizontal';
}

export const TextField = <T extends FieldValues>({
  label,
  required,
  isReadOnly,
  showError,
  isSmallSize,
  layoutForm,
  ...props
}: TextFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  const { value, ...rest } = field;

  return (
    <FieldWrapper label={label} error={error} required={required} showError={showError} layoutForm={layoutForm}>
      <TextInput error={error} value={value ?? ''} {...rest} readOnly={isReadOnly} isSmallSize={isSmallSize} />
    </FieldWrapper>
  );
};
